import React, { Component,Fragment }  from 'react';
import {Radio, Input, Button, Form, Table, Space, DatePicker, PageHeader} from 'antd';
import moment from 'moment';
import '../../style.css';


//风险投资
const dataSource1 = [
    {
        key: '0',
        type: 'Edward King 0',
        name: '32',
        code: 'London, Park Lane no. 0',
        amount:'',
    },
    {
        key: '1',
        type: 'Edward King 0',
        name: '32',
        code: 'London, Park Lane no. 0',
        amount:'',
    },
];
const columns1 = [
    {
        title: '法人类型',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '组织机构代码或统一社会信用代码',
        dataIndex: 'code',
        key: 'code',
    },
    {
        title: '投资额（万元）',
        dataIndex: 'amount',
        key: 'amount',
    },
];
//股权结构
const dataSource2 = [
    {
        key: '0',
        type: 'Edward King 0',
        name: '32',
        code: 'London, Park Lane no. 0',
        amount:'',
    },
    {
        key: '1',
        type: 'Edward King 0',
        name: '32',
        code: 'London, Park Lane no. 0',
        amount:'',
    },
];
const columns2 = [
    {
        title: '公民类型',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '身份证（护照）号',
        dataIndex: 'code',
        key: 'code',
    },
    {
        title: '投资额（万元）',
        dataIndex: 'amount',
        key: 'amount',
    },
];
const dataSource3 = [
    {
        key: '0',
        type: 'Edward King 0',
        name: '32',
        code: 'London, Park Lane no. 0',
        amount:'',
    },
    {
        key: '1',
        type: 'Edward King 0',
        name: '32',
        code: 'London, Park Lane no. 0',
        amount:'',
    },
];
const columns3 = [
    {
        title: '法人类型',
        dataIndex: 'type',
        key: 'type',
    },
    {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '组织机构代码或统一社会信用代码',
        dataIndex: 'code',
        key: 'code',
    },
    {
        title: '投资额（万元）',
        dataIndex: 'amount',
        key: 'amount',
    },
];
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
    };
class EnterpriseRegistration extends Component {

    handleApproveSubmit(){

    }
    render() {
        return(
            <Fragment>
                <div>
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="企业注册登记表"
                        >
                        </PageHeader>
                    </div>
                    <Form
                        {...layout}
                        name="basic"
                        initialValues={{ remember: true }}
                    >
                        <Form.Item
                            label="企业名称"
                            name="username"
                            rules={[{ required: true, message: '请输入企业名称!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="注册时间"
                            name="password"
                            rules={[{ required: true, message: '请输入注册时间!' }]}
                        >
                            <Space direction="vertical" size={12}>
                                <DatePicker defaultValue={moment('2015/01/01', 'YYYY-MM-DD')} format={'YYYY-MM-DD'}/>
                            </Space>
                        </Form.Item>
                        <Form.Item
                            label="注册类型"
                            name="username"
                            rules={[{ required: true, message: '请输入注册类型!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="外资来源地"
                            name="username"
                            rules={[{ required: true, message: '请输入外资来源地！' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="注册资金"
                            name="username"
                            rules={[{ required: true, message: '请输入注册资金!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="所属行业"
                            name="username"
                            rules={[{ required: true, message: '请输入所属行业!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="企业规模"
                            name="username"
                            rules={[{ required: true, message: '请输入企业规模!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="统一社会信用代码"
                            name="username"
                            rules={[{ required: true, message: '请输入统一社会信用代码!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="行政区域"
                            name="username"
                            rules={[{ required: true, message: '请输入行政区域!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="邮政编码"
                            name="username"
                            rules={[{ required: true, message: '请输入邮政编码!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="企业所得税征收方式"
                            name="username"
                            rules={[{ required: true, message: '请输入企业所得税征收方式!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="通信地址"
                            name="username"
                            rules={[{ required: true, message: '请输入通信地址!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <div style={{textAlign:'center',fontSize:'20px',fontFamily:'SimHei',paddingBottom:'10px',color:'blue'}}>
                            添加企业法定代表人基本信息</div>
                        <Form.Item
                            label="姓名"
                            name="username"
                            rules={[{ required: true, message: '请输入法人姓名!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="手机"
                            name="username"
                            rules={[{ required: true, message: '请输入手机号码!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="电话"
                            name="username"
                            rules={[{ required: true, message: '请输入电话号码!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="传真"
                            name="username"
                            rules={[{ required: true, message: '请输入传真!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="E-mail"
                            name="username"
                            rules={[{ required: true, message: '请输入E-mail!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <div style={{textAlign:'center',fontSize:'20px',fontFamily:'SimHei',paddingBottom:'10px',color:'blue'}}>
                            添加联系人基本信息</div>
                        <Form.Item
                            label="姓名"
                            name="username"
                            rules={[{ required: true, message: '请输入法人姓名!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="手机"
                            name="username"
                            rules={[{ required: true, message: '请输入手机号码!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="电话"
                            name="username"
                            rules={[{ required: true, message: '请输入电话号码!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="传真"
                            name="username"
                            rules={[{ required: true, message: '请输入传真!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="E-mail"
                            name="username"
                            rules={[{ required: true, message: '请输入E-mail!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="企业是否上市"
                            name="username"
                            rules={[{ required: true, message: '请选择企业是否上市!' }]}
                        >
                            <Radio.Group name="radiogroup" defaultValue={0}>
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            label="上市时间"
                            name="username"
                            rules={[{ required: false, message: '如果是，请输入上市时间!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="股票代码"
                            name="username"
                            rules={[{ required: false, message: '如果是，请输入股票代码!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="上市类型"
                            name="username"
                            rules={[{ required: false, message: '如果是，请输入上市类型!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="是否属于国家级高新区内企业"
                            name="username"
                            rules={[{ required: true, message: '请选择是否属于国家级高新区内企业!' }]}
                        >
                            <Radio.Group name="radiogroup" defaultValue={0}>
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            label="高新区名称"
                            name="username"
                            rules={[{ required: false, message: '如果是，请输入高新区名称!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="技术领域"
                            name="username"
                            rules={[{ required: true, message: '请输入技术领域!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <div style={{textAlign:'center',fontSize:'20px',fontFamily:'SimHei',paddingBottom:'10px',color:'blue'}}>
                            添加风险投资相关信息</div>
                        <Button onClick={this.handleAdd} type="primary" style={{ marginBottom: 16 }}>
                            Add a row
                        </Button>
                        <Table
                            bordered={true}
                            dataSource={dataSource1}
                            columns={columns1}
                            pagination={true}

                        />
                        <div style={{textAlign:'center',fontSize:'20px',fontFamily:'SimHei',paddingBottom:'10px',color:'blue'}}>
                            添加股权结构相关信息</div>
                        <Button onClick={this.handleAdd} type="primary" style={{ marginBottom: 16 }}>
                            Add a row
                        </Button>
                        <Table
                            bordered={true}
                            dataSource={dataSource2}
                            columns={columns2}
                            pagination={true}

                        />
                        <Button onClick={this.handleAdd} type="primary" style={{ marginBottom: 16 }}>
                            Add a row
                        </Button>
                        <Table
                            bordered={true}
                            dataSource={dataSource3}
                            columns={columns3}
                            pagination={true}

                        />
                        <Form.Item
                            label="经营范围"
                            name="username"
                            rules={[{ required: true, message: '请输入经营范围!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="企业简介"
                            name="username"
                            rules={[{ required: true, message: '请输入经营范围!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Button
                            style={{float:"right",marginRight:"60px"}}
                            type="primary"
                            onClick={this.handleApproveSubmit}
                        >提交</Button>
                    </Form>
                    </div>
            </Fragment>
        )
    }
    //加一行待解决
    // handleAdd = () => {
    //     const { datasource } = datasource;
    //     const newData = {
    //         key: '',
    //         name: '',
    //         age: '32',
    //         address: '',
    //     };
    //     this.setState({
    //         dataSource: [...dataSource, newData],
    //     });
    // };
}
export default EnterpriseRegistration;